import { Loader } from "lucide-react";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useDeleteCustomVerificationTypeMutation } from "@/data/mutations";
import { useDialogState } from "@/hooks/use-dialog-state";

export const DeleteVerificationTypeDialog = () => {
  const { dialog, closeDialog } = useDialogState();
  const deleteVerificationTypeMutation =
    useDeleteCustomVerificationTypeMutation();

  const handleSubmit = () => {
    if (dialog?.name === "delete-verification-type") {
      deleteVerificationTypeMutation.mutate(dialog.params.verificationTypeId);
    }
  };

  if (dialog?.name !== "delete-verification-type") {
    return null;
  }

  return (
    <AlertDialog open={true}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Delete {dialog.params.verificationTypeName}
          </AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete the{" "}
            <b className="text-black">{dialog.params.verificationTypeName}</b>{" "}
            verification type? This action is irreversible.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={closeDialog}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleSubmit}
            disabled={deleteVerificationTypeMutation.isPending}
          >
            {deleteVerificationTypeMutation.isPending ? (
              <Loader className="mr-2 h-4 w-4 animate-spin" />
            ) : null}
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
